import { createProjectFilterReducer, listFiltersToProjectQuery, ProjectFiltersState } from './project-list-filters'
import { createAction, createReducer, isActionOf } from 'typesafe-actions'
import { combineReducers } from 'redux'

import { SortDirection } from '../../constants/direction'
import { taskStatusFilters } from '../../components/pages/projects/ProjectList/ProjectFilters/filters'
import { combineEpics } from 'redux-observable'
import { createPaginatedAction } from '../../utils/redux-utils'
import { RootEpic } from '../root'
import { concatMap, debounceTime, filter, map, scan, startWith, switchMap, takeUntil } from 'rxjs/operators'
import { apiRequests } from '../../http/config'
import { toastFailedResponse } from '../../components/controls/Toaster/Toaster'
import { SearchResult } from '../../responses/search'
import { RequestStatus } from '../../responses/response'


export const searchActions = {
    updateFilters: createAction('@SEARCH/UPDATE_FILTERS')<Partial<ProjectFiltersState>>(),
    clearFilters: createAction('@SEARCH/CLEAR_FILTERS')(),
    list: createPaginatedAction(
        '@SEARCH/LIST_INIT',
        '@SEARCH/LIST_MORE',
        '@SEARCH/LIST_SUCCESS',
        '@SEARCH/LIST_FAILURE',
    )<ProjectFiltersState, { offset: number, results: SearchResult[], total: number }>()
}

export interface SearchState {
    status: RequestStatus,
    filters: ProjectFiltersState,
    total: number,
    results: SearchResult[],
}

export const searchReducer = combineReducers<SearchState>({
    status: createReducer(RequestStatus.INITIAL)
        .handleAction([searchActions.list.init, searchActions.list.more], () => RequestStatus.FETCHING)
        .handleAction(searchActions.list.success, () => RequestStatus.SUCCESS)
        .handleAction(searchActions.list.failure, () => RequestStatus.FAILURE),
    results: createReducer<SearchResult[]>([])
        .handleAction(searchActions.list.success, (state, action) => action.payload.offset === 0?
            action.payload.results:
            state.concat(action.payload.results)
        ),
    total: createReducer(0)
        .handleAction(searchActions.list.success, (_, action) => action.payload.total)
        .handleAction(searchActions.list.failure, () => 0),
    filters: createProjectFilterReducer({
        dropdowns: {},
        openedAt: [undefined, undefined],
        projectStatus: [],
        sortField: null,
        sortDirection: SortDirection.ASC,
        taskStatus: taskStatusFilters[0],
        search: '',
        tags: [],
        object_design_status: null,
        object_production_status: null
    }, {
        update: searchActions.updateFilters,
        clear: searchActions.clearFilters,
    })
})

const LIMIT = 50

const list: RootEpic = action$ => action$.pipe(
    filter(isActionOf(searchActions.list.init)),
    debounceTime(2000),
    switchMap(action => action$.pipe(
        takeUntil(action$.pipe(filter(isActionOf(searchActions.list.failure)))),
        startWith(searchActions.list.more()),
        filter(isActionOf(searchActions.list.more)),
        scan(offset => offset + LIMIT, -LIMIT),
        concatMap(offset => apiRequests.search.list({
                query: {
                    ...listFiltersToProjectQuery(action.payload),
                    limit: LIMIT,
                    offset,
                }
            }).pipe(
            map(res => res.response.success ?
                searchActions.list.success({
                    offset,
                    results: res.response.rows,
                    total: res.response.total
                }) :
                searchActions.list.failure(toastFailedResponse(res.response, 'Не удалось получить результаты поиска'))
            )
            )
        ),
    )),
)

export const searchEpic = combineEpics(list)